import type { NavamsaRequest, NavamsaResponse, D9Planet } from "@ishvaram/api-client";
export type { NavamsaRequest, NavamsaResponse, D9Planet };
import { apiRequest } from "./_fetch";

export async function calculateNavamsa(data: NavamsaRequest): Promise<NavamsaResponse> {
  return apiRequest<NavamsaResponse>("/navamsa-chart", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}
